import React, { FC } from 'react';

export const LogoSvg: FC<{}> = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="32"
    viewBox="0 0 150 32"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
      transform="translate(-71 -38) translate(71 38.343)"
    >
      <path
        fill="#EE295C"
        d="M27.253 6.873A25.226 25.226 0 0115.69 26.294 25.22 25.22 0 014.125 6.804a25.336 25.336 0 0123.127.07zm3.096-2.912A29.322 29.322 0 0015.623 0a29.318 29.318 0 00-14.58 3.879L0 4.475l.028 1.203C.257 15.99 5.733 25.237 14.68 30.412l1.011.585 1.013-.585c8.916-5.158 14.394-14.374 14.65-24.65l.03-1.198-1.035-.603z"
      ></path>
      <path
        fill="#FFF"
        d="M49.6590865 17.1245192L44.6744712 17.1245192 44.6744712 22.44375 40.4614904 22.44375 40.4614904 8.53413462 44.6744712 8.53413462 44.6744712 13.4552885 49.6590865 13.4552885 49.6590865 8.53413462 53.870625 8.53413462 53.870625 22.44375 49.6590865 22.44375z"
      ></path>
      <path
        fill="#FFF"
        d="M64.036 12.016c-2.023 0-3.336 1.543-3.336 3.484 0 1.939 1.313 3.482 3.336 3.482 2.022 0 3.336-1.543 3.336-3.482 0-1.94-1.314-3.484-3.336-3.484m0-3.711c4.297 0 7.611 2.918 7.611 7.195 0 4.274-3.314 7.193-7.61 7.193-4.297 0-7.613-2.919-7.613-7.193 0-4.277 3.316-7.195 7.612-7.195"
      ></path>
      <path
        fill="#FFF"
        d="M79.5813462 18.189375L77.0371154 22.4427404 72.0741346 22.4427404 76.7255769 15.3119712 72.3871154 8.53456731 77.3299038 8.53456731 79.5813462 12.4980288 81.7924038 8.53456731 86.7770192 8.53456731 82.4385577 15.2903365 87.0885577 22.4427404 82.1255769 22.4427404z"
      ></path>
      <path
        fill="#FFF"
        d="M98.0883173 17.1245192L93.1037019 17.1245192 93.1037019 22.44375 88.8907212 22.44375 88.8907212 8.53413462 93.1037019 8.53413462 93.1037019 13.4552885 98.0883173 13.4552885 98.0883173 8.53413462 102.299856 8.53413462 102.299856 22.44375 98.0883173 22.44375z"
      ></path>
      <path
        fill="#FFF"
        d="M105.604 8.534h4.275v8.048c0 1.336.687 2.4 2.42 2.4 1.708 0 2.399-1.064 2.399-2.4V8.534h4.275v8.174c0 3.463-1.982 5.985-6.674 5.985-4.693 0-6.695-2.522-6.695-5.962V8.534z"
      ></path>
      <path
        fill="#FFF"
        d="M126.487933 14.9779327L126.487933 22.4433173 122.274952 22.4433173 122.274952 8.53370192 126.613413 8.53370192 131.450913 15.541875 131.450913 8.53370192 135.663894 8.53370192 135.663894 22.4433173 131.618221 22.4433173z"
      ></path>
      <path
        fill="#FFF"
        d="M141.950481 12.2045192L138.217788 12.2045192 138.217788 8.53384615 149.874519 8.53384615 149.874519 12.2045192 146.163462 12.2045192 146.163462 22.4434615 141.950481 22.4434615z"
      ></path>
    </g>
  </svg>
);
